import { useState, useEffect, useRef } from "react";
import { db } from "./firebase";
import { collection, addDoc, Timestamp, doc, setDoc, deleteDoc } from "firebase/firestore";
import AOS from "aos";
import "aos/dist/aos.css";
import { 
  FaWhatsapp, FaArrowRight, FaCheck, FaUserMd, FaClock, FaFileMedical, 
  FaPrescriptionBottleAlt, FaFlask, FaFileAlt, FaHeadset, FaShieldAlt,
  FaStar, FaVideo, FaCalendarCheck, FaAward, FaStethoscope,
  FaHeartbeat, FaUserShield, FaCertificate, FaRocket, FaPhoneAlt
} from "react-icons/fa";

import logo from "./IMG/logo.png";
import logo2 from "./IMG/logo2.png";
import doutoraFoto from "./IMG/foto.jpeg";

import "./App.css";

// Event snippet for Contato (2) conversion page
function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  window.gtag('event', 'conversion', {
      'send_to': 'AW-17548308760/w_6gCO6kopgbEJji169B',
      'value': 1.0,
      'currency': 'BRL',
      'event_callback': callback
  });
  return false;
}

function App() {
  const [isVisible, setIsVisible] = useState(false);
  const [activeUsers, setActiveUsers] = useState(0);
  const featuresRef = useRef(null);
  const ctaRef = useRef(null);
  const heroRef = useRef(null);

  // Form state (mantendo original: nome, data nascimento, email)
  const [formData, setFormData] = useState({
    name: '',
    birthdate: '',
    email: ''
  });

  useEffect(() => {
    AOS.init({ 
      duration: 1000,
      once: true,
      easing: 'ease-in-out-quart'
    });

    // Registrar visita (mantendo nomenclatura original)
    recordDoutorAgoraVisit();
    registerDoutorAgoraActiveUser();

    // Simular usuários online
    const updateActiveUsers = () => {
      setActiveUsers(Math.floor(Math.random() * 15) + 8);
    };
    updateActiveUsers();
    const usersInterval = setInterval(updateActiveUsers, 30000);

    // Observador de interseção para animações
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (featuresRef.current) observer.observe(featuresRef.current);
    if (ctaRef.current) observer.observe(ctaRef.current);
    if (heroRef.current) observer.observe(heroRef.current);

    return () => {
      clearInterval(usersInterval);
      if (featuresRef.current) observer.unobserve(featuresRef.current);
      if (ctaRef.current) observer.unobserve(ctaRef.current);
      if (heroRef.current) observer.unobserve(heroRef.current);
    };
  }, []);

  // Função para registrar conversão no Google Ads (pixel atualizado)
  const trackConversion = (url, buttonName) => {
    // Primeiro registra o clique no Firestore
    recordDoutorAgoraClick(buttonName);
    
    // Depois dispara a conversão do Google Ads (novo pixel)
    gtag_report_conversion(url);
    return false;
  };

  // Função para registrar uma visita no Firestore (mantendo nomenclatura)
  const recordDoutorAgoraVisit = async () => {
    try {
      await addDoc(collection(db, "doutorAgoraPageVisits"), {
        timestamp: Timestamp.now(),
      });
    } catch (error) {
      console.error("Erro ao registrar visita:", error);
    }
  };

  // Função para registrar um usuário ativo (mantendo nomenclatura)
  const registerDoutorAgoraActiveUser = async () => {
    const userRef = doc(collection(db, "doutorAgoraActiveUsers"), `user_${Date.now()}`);
    await setDoc(userRef, {
      lastActive: Timestamp.now(),
    });

    const heartbeatInterval = setInterval(async () => {
      await setDoc(userRef, { lastActive: Timestamp.now() }, { merge: true });
    }, 5000);

    window.addEventListener("beforeunload", async () => {
      clearInterval(heartbeatInterval);
      await deleteDoc(userRef);
    });
  };

  // Função para registrar um clique no botão (mantendo nomenclatura)
  const recordDoutorAgoraClick = async (buttonName) => {
    try {
      await addDoc(collection(db, "doutorAgoraClickMetrics"), {
        button: buttonName,
        timestamp: Timestamp.now(),
      });
    } catch (error) {
      console.error("Erro ao registrar clique:", error);
    }
  };

  // Form handlers (mantendo original)
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = `🏥 AGENDAMENTO - Médico Agora 24h\n\n👤 Nome: ${formData.name}\n🎂 Data Nascimento: ${formData.birthdate}\n📧 E-mail: ${formData.email}\n\n`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/5538984237442?text=${encodedMessage}`;
    
    trackConversion(whatsappUrl, "FORMULARIO DE AGENDAMENTO");
    
    setFormData({
      name: '',
      birthdate: '',
      email: ''
    });
  };

  return (
    <div className="doutor-agora-container">
      {/* Barra de Urgência Premium */}
      <div className="urgency-bar-premium">
        <div className="container">
          <div className="urgency-content-premium">
            <div className="urgency-indicator-premium">
              <div className="pulse-dot-premium"></div>
              <span><strong>{activeUsers} pessoas</strong> consultando médicos agora</span>
            </div>
            <div className="urgency-cta-premium">
              <button 
                className="mini-cta-button-premium"
                onClick={() => trackConversion("https://wa.me/5538984237442", "BARRA URGENCIA PREMIUM")}
              >
                <FaWhatsapp /> ATENDIMENTO IMEDIATO
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Hero Section Premium */}
      <header className="hero-section-premium" ref={heroRef}>
        <div className="hero-effects-premium">
          <div className="medical-crosses-premium">
            <div className="cross-1"></div>
            <div className="cross-2"></div>
            <div className="cross-3"></div>
          </div>
          <div className="light-effect-premium"></div>
        </div>

        <div className="container">
          <div className="hero-header-premium" data-aos="fade-down">
            <div className="logo-container-premium">
              <img src={logo} alt="Médico Agora 24 Horas" className="logo-premium" />
            </div>
            <div className="trust-badges-premium">
              <div className="trust-badge-premium">
                <FaCertificate />
                <span>CFM Aprovado</span>
              </div>
              <div className="trust-badge-premium">
                <FaShieldAlt />
                <span>100% Seguro</span>
              </div>
              <div className="trust-badge-premium">
                <FaStar />
                <span>Nota 5.0★</span>
              </div>
            </div>
          </div>
          
          <div className="hero-content-premium">
            <div className="doctor-presentation-premium" data-aos="fade-right" data-aos-delay="200">
              <div className="photo-frame-premium">
                <img src={doutoraFoto} alt="Dra. Brunna Lopes" className="doctor-photo-premium" />
                <div className="glow-effect-premium"></div>
                <div className="online-badge-premium">
                  <div className="online-dot-premium"></div>
                  <span>ONLINE AGORA</span>
                </div>
              </div>
              <div className="doctor-badge-premium">
                <h4>Dra. Brunna Lopes </h4>
                <p>CRM-MG 102898</p>
                <div className="doctor-specialty-premium">
                  <FaStethoscope />
                  <span>Clínica Geral</span>
                </div>
              </div>
            </div>
            
            <div className="hero-text-premium" data-aos="fade-left" data-aos-delay="200">
              <div className="urgency-alert-premium">
                <FaHeartbeat className="pulse-icon-premium" />
                <span>ATENDIMENTO MÉDICO IMEDIATO</span>
              </div>

              <h1 className="hero-title-premium">
                <span className="title-main-premium">CONSULTA MÉDICA ONLINE</span>
                <span className="title-sub-premium">Com Clínico Geral Especializado</span>
                <span className="price-highlight-premium">
                  <span className="price-label-premium">Por apenas</span>
                  <span className="price-value-premium">R$ 39,90</span>
                </span>
              </h1>

              <div className="benefits-preview-premium">
                <div className="benefit-item-premium">
                  <FaCheck />
                  <span>Resposta <strong>IMEDIATA</strong></span>
                </div>
                <div className="benefit-item-premium">
                  <FaCheck />
                  <span><strong>Atestado médico</strong> incluso se necessário</span>
                </div>
                <div className="benefit-item-premium">
                  <FaCheck />
                  <span>Válido em <strong>todo o Brasil</strong></span>
                </div>
              </div>
              
              <form onSubmit={handleSubmit} className="appointment-form-premium">
                <div className="form-header-premium">
                  <FaCalendarCheck className="form-icon-premium" />
                  <h3>Agendar Consulta Médica</h3>
                  <p>Preencha os dados para <strong>atendimento imediato</strong></p>
                </div>

                <div className="form-group-premium">
                  <input 
                    type="text" 
                    name="name" 
                    placeholder="Nome completo *" 
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                
                <div className="form-group-premium">
                  <input 
                    type="text" 
                    name="birthdate" 
                    placeholder="Data de nascimento (dd/mm/aaaa) *" 
                    value={formData.birthdate}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                
                <div className="form-group-premium">
                  <input 
                    type="email" 
                    name="email" 
                    placeholder="E-mail *" 
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                
                <button type="submit" className="cta-button-premium pulse-strong-premium">
                  <div className="button-content-premium">
                    <FaWhatsapp className="button-icon-premium" />
                    <span className="button-text-premium">CONSULTAR MÉDICO AGORA</span>
                    <FaArrowRight className="button-arrow-premium" />
                  </div>
                  <div className="button-subtext-premium">Resposta Imediata • R$ 39,90</div>
                </button>

                <div className="form-security-premium">
                  <FaUserShield />
                  <span>Seus dados estão 100% protegidos</span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </header>

      {/* Services Section Premium */}
      <section className="services-section-premium">
        <div className="container">
          <div className="section-header-premium" data-aos="fade-up">
            <div className="section-badge-premium">
              <FaAward />
              <span>SERVIÇO MÉDICO ESPECIALIZADO</span>
            </div>
            <h2>Consulta Médica Online Completa</h2>
            <p>Atendimento profissional de clínica geral com <strong>possibilidade de atestado médico</strong></p>
          </div>
          
          <div className="service-card-single-premium" data-aos="fade-up" data-aos-delay="200">
            <div className="service-badge-featured-premium">
              <FaRocket />
              <span>ATENDIMENTO IMEDIATO</span>
            </div>
            
            <div className="service-content-premium">
              <div className="service-icon-premium">
                <FaUserMd />
              </div>
              
              <div className="service-info-premium">
                <h3>Consulta Médica Online - Clínica Geral</h3>
                <p className="service-description-premium">
                  Atendimento completo com médico especialista via videoconferência. 
                  <strong> Inclui atestado médico quando necessário</strong> com validade nacional.
                </p>
                
                <div className="service-features-premium">
                  <div className="feature-premium">
                    <FaVideo />
                    <span>Consulta por videoconferência</span>
                  </div>
                  <div className="feature-premium">
                    <FaFileMedical />
                    <span><strong>Atestado médico incluso</strong></span>
                  </div>
                  <div className="feature-premium">
                    <FaPrescriptionBottleAlt />
                    <span>Prescrições e receitas</span>
                  </div>
                  <div className="feature-premium">
                    <FaClock />
                    <span>Disponível 24 horas</span>
                  </div>
                </div>
              </div>
              
              <div className="service-cta-premium">
                <div className="service-price-premium">
                  <span className="price-currency-premium">R$</span>
                  <span className="price-amount-premium">39,90</span>
                  <span className="price-period-premium">consulta completa</span>
                </div>
                
                <button 
                  className="service-button-premium"
                  onClick={() => trackConversion("https://wa.me/5538984237442", "CONSULTA MEDICA PREMIUM")}
                >
                  <FaWhatsapp />
                  <span>AGENDAR CONSULTA AGORA</span>
                  <FaArrowRight />
                </button>
                
                <div className="service-guarantee-premium">
                  <FaShieldAlt />
                  <span>Atestado médico incluso se necessário</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section Premium */}
      <section className="about-section-premium">
        <div className="container">
          <div className="about-content-premium">
            <div className="about-text-premium" data-aos="fade-right">
              <div className="about-badge-premium">
                <FaAward />
                <span>EXCELÊNCIA EM TELEMEDICINA</span>
              </div>
              
              <h2>Atendimento Clínico Geral Online por <span className="highlight-premium">R$39,90</span></h2>
              
              <div className="about-highlights-premium">
                <p className="highlight-text-premium">
                  ✅ <strong>Atestado médico incluso</strong> quando necessário<br/>
                  ✅ Com agilidade e comodidade direto na sua casa<br/>
                  ✅ Cuide da sua saúde onde estiver
                </p>
              </div>
              
              <p className="about-description-premium">
                Nossa equipe médica oferece atendimento humanizado e profissional através da telemedicina. 
                <strong>Todos os nossos médicos possuem CRM ativo</strong> e especialização em clínica geral.
              </p>
              
              <button 
                className="cta-button-secondary-premium"
                onClick={() => trackConversion("https://wa.me/5538984237442", "SOBRE A DOUTORA")}
              >
                <FaWhatsapp /> Conheça nossa equipe médica
              </button>
            </div>
            
            <div className="benefits-grid-premium" ref={featuresRef} data-aos="fade-left">
              <div className="benefit-premium">
                <div className="benefit-icon-premium"><FaUserMd /></div>
                <h3>Médicos Especialistas</h3>
                <p>Profissionais qualificados com CRM ativo para cuidar da sua saúde</p>
              </div>
              
              <div className="benefit-premium highlighted-premium">
                <div className="benefit-icon-premium"><FaFileMedical /></div>
                <h3>Atestado Médico Online</h3>
                <p><strong>Incluso na consulta</strong> - Receba seu atestado digital com validade nacional</p>
              </div>
              
              <div className="benefit-premium">
                <div className="benefit-icon-premium"><FaClock /></div>
                <h3>Disponível 24 Horas</h3>
                <p>Atendimento quando você precisar, a qualquer hora do dia</p>
              </div>
              
              <div className="benefit-premium">
                <div className="benefit-icon-premium"><FaPrescriptionBottleAlt /></div>
                <h3>Renovação de Receita</h3>
                <p>Renove suas receitas médicas sem sair de casa</p>
              </div>
              
              <div className="benefit-premium">
                <div className="benefit-icon-premium"><FaFlask /></div>
                <h3>Pedidos de Exames</h3>
                <p>Solicitação de exames quando necessário para diagnóstico</p>
              </div>
              
              <div className="benefit-premium">
                <div className="benefit-icon-premium"><FaFileAlt /></div>
                <h3>Laudos Médicos</h3>
                <p>Análise e interpretação profissional de exames</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section Premium */}
      <section className="cta-section-premium" ref={ctaRef}>
        <div className="cta-effects-premium">
          <div className="light-effect-cta-premium"></div>
          <div className="medical-pattern-premium"></div>
        </div>

        <div className="container">
          <div className="cta-content-premium">
            <div className="cta-text-premium" data-aos="fade-right">
              <div className="cta-badge-premium">
                <FaRocket />
                <span>NÃO ESPERE SUA SAÚDE PIORAR</span>
              </div>
              
              <h2>Atendimento Médico 24 Horas com Abrangência Nacional</h2>
              
              <div className="cta-features-premium">
                <div className="cta-feature-premium">
                  <FaCheck />
                  <span><strong>Atestado médico incluso</strong> se necessário</span>
                </div>
                <div className="cta-feature-premium">
                  <FaCheck />
                  <span>Consulta online com <strong>clínico geral</strong></span>
                </div>
                <div className="cta-feature-premium">
                  <FaCheck />
                  <span>Renovação de receita e pedidos de exames</span>
                </div>
                <div className="cta-feature-premium">
                  <FaCheck />
                  <span><strong>Resposta imediata</strong> - 24 horas por dia</span>
                </div>
              </div>
              
              <button 
                className="cta-button-final-premium pulse-strong-premium"
                onClick={() => trackConversion("https://wa.me/5538984237442", "CTA FINAL")}
              >
                <FaWhatsapp className="button-icon-large-premium" />
                <div className="button-text-container-premium">
                  <span className="button-main-text-premium">CONSULTAR MÉDICO AGORA</span>
                  <span className="button-sub-text-premium">R$ 39,90 • Atestado Incluso</span>
                </div>
                <FaArrowRight className="button-arrow-premium" />
              </button>
            </div>
            
            <div className="cta-image-premium" data-aos="fade-left">
              <div className="doctor-card-cta-premium">
                <div className="photo-frame-cta-premium">
                  <img src={doutoraFoto} alt="Dra. Brunna Lopes atendendo" className="doctor-photo-cta-premium" />
                  <div className="glow-effect-cta-premium"></div>
                </div>
                <div className="doctor-quote-premium">
                  <div className="quote-stars-premium">
                    {[1,2,3,4,5].map(i => <FaStar key={i} />)}
                  </div>
                  <p>"Sua saúde não pode esperar. Estamos aqui para você 24 horas por dia."</p>
                  <div className="quote-author-premium">
                    <span>- Dra. Brunna Lopes, CRM-MG 102898</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Premium */}
      <footer className="footer-premium">
        <div className="container">
          <div className="footer-content-premium">
            <div className="footer-logo-premium">
              <img src={logo} alt="Médico Agora 24 Horas" className="logo-footer-premium" />
            </div>
            <h3 className="footer-title-premium">Médico Agora 24 Horas</h3>
            <p className="footer-description-premium">
              Telemedicina com qualidade, conveniência e <strong>atestado médico incluso</strong>
            </p>
            
            <div className="footer-badges-premium">
              <div className="footer-badge-premium">
                <FaCertificate />
                <span>CFM Regulamentado</span>
              </div>
              <div className="footer-badge-premium">
                <FaShieldAlt />
                <span>Dados Seguros</span>
              </div>
              <div className="footer-badge-premium">
                <FaStar />
                <span>5.0★ Avaliação</span>
              </div>
            </div>
            
            <div className="footer-cta-premium">
              <button 
                className="whatsapp-button-premium pulse-premium"
                onClick={() => trackConversion("https://wa.me/5538984237442", "FOOTER WHATSAPP")}
              >
                <FaWhatsapp /> 
                <div className="whatsapp-button-text-premium">
                  <span>Fale conosco no WhatsApp</span>
                  <small>Atendimento imediato disponível</small>
                </div>
              </button>
            </div>
            
            <div className="copyright-premium">
              © {new Date().getFullYear()} Médico Agora 24 Horas. Todos os direitos reservados.
              <br/>
              <small>Telemedicina regulamentada pelo Conselho Federal de Medicina</small>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;